import { useReveal } from "@/hooks/useReveal";

export function SectionHeader({ num, kicker, title, sub }) {
  return (
    <div className="reveal max-w-4xl">
      <div className="flex items-center gap-3 mb-6">
        <span className="section-num">{num}</span>
        <span className="h-px w-10 bg-white/15" />
        <span className="section-num !text-[#38BDF8]">{kicker}</span>
      </div>
      <h2 className="font-display text-white text-[clamp(32px,4.6vw,56px)] leading-[1.06] font-medium tracking-tight">
        {title}
      </h2>
      {sub && (
        <p className="mt-5 text-[#CBD5E1] text-[17px] leading-relaxed max-w-2xl">
          {sub}
        </p>
      )}
    </div>
  );
}

export function SectionWrap({ id, children, className = "" }) {
  useReveal();
  return (
    <section
      id={id}
      className={`relative max-w-[1440px] mx-auto px-6 lg:px-12 py-28 lg:py-36 ${className}`}
    >
      {children}
    </section>
  );
}
